import { getShortDate } from './wix-design-systems-locale-utils';
export const getFilter = validation => {
  var _validation$string, _validation$string2;
  const minimum = validation == null || (_validation$string = validation.string) == null || (_validation$string = _validation$string.dateOptions) == null ? void 0 : _validation$string.minimum;
  const maximum = validation == null || (_validation$string2 = validation.string) == null || (_validation$string2 = _validation$string2.dateOptions) == null ? void 0 : _validation$string2.maximum;
  if (minimum) {
    return date => date > new Date();
  }
  if (maximum) {
    return date => date < new Date();
  }
  return undefined;
};
export const formatDate = date => {
  if (date) {
    const _date = new Date(date);
    const year = _date.getFullYear();
    const month = (_date.getMonth() + 1).toString().padStart(2, '0');
    const day = _date.getDate().toString().padStart(2, '0');
    return [year, month, day].join('-');
  }
  return null;
};
export const getLocalizedValue = function (value, locale) {
  if (locale === void 0) {
    locale = 'en';
  }
  return getShortDate(locale, new Date(new Date(value).setHours(0, 0, 0, 0)));
};
//# sourceMappingURL=date-picker-utils.js.map